export default __webpack_public_path__ + "static/media/004-B-cartepaiment.e841335d.svg";